import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2 } from 'lucide-react';

const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
    }
};

const B2BPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="pt-24 min-h-screen">
            <section className="py-20 px-6 max-w-7xl mx-auto">
                <motion.div initial="hidden" animate="visible" variants={fadeInUp} className="max-w-4xl">
                    <p className="text-[#FF5A1F] text-sm font-semibold tracking-[0.15em] uppercase mb-6">
                        B2B Service Companies
                    </p>
                    <h1 className="text-4xl md:text-6xl font-bold text-white mb-8 tracking-[-0.03em] font-sans uppercase leading-[1.05]">
                        Command Authority in the Enterprise Space.
                    </h1>
                    <p className="text-lg md:text-xl text-[#A0A0A0] max-w-2xl leading-relaxed mb-12">
                        Transform your online presence into a 24/7 sales asset. We build B2B websites that establish immediate trust with C-suite decision-makers and generate highly qualified inbound leads.
                    </p>
                    <button
                        onClick={() => navigate("/strategy")}
                        className="cta-premium px-8 py-4 text-white font-semibold rounded-[20px] inline-flex items-center gap-2"
                    >
                        Get a B2B Strategy <ArrowUpRight className="w-5 h-5" />
                    </button>
                </motion.div>
            </section>

            <section className="py-20 px-6 section-elevated">
                <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                        <h2 className="text-3xl font-bold text-white mb-6 uppercase tracking-tight">How We Elevate B2B Brands</h2>
                        <ul className="space-y-6">
                            {[
                                "Professional Aesthetics: Looking like the industry leader you are.",
                                "Authority Building: Highlighting case studies and trust signals.",
                                "Clear Conversion Paths: Directing enterprise traffic directly to your sales team.",
                                "Content Infrastructure: Built for SEO dominance and thought leadership."
                            ].map((item, i) => (
                                <li key={i} className="flex items-start gap-4">
                                    <CheckCircle2 className="w-6 h-6 text-[#FF5A1F] flex-shrink-0" />
                                    <span className="text-[#A0A0A0]">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                    <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}>
                        <div className="aspect-square rounded-[24px] overflow-hidden border border-white/[0.04]">
                            <img src="https://images.unsplash.com/photo-1620287341056-49a2f1ab2fdc?crop=entropy&cs=srgb&fm=jpg&w=800&q=80" alt="B2B Strategy" className="w-full h-full object-cover img-bw-premium hover:filter-none transition-all duration-700" />
                        </div>
                    </motion.div>
                </div>
            </section>
        </main>
    );
};

export default B2BPage;
